import { Observable } from 'rxjs'
import { CheckDuplicateEmailTypeModel } from '../models/register.model'
import { BaseService } from '../services/base.service'

export abstract class RegisterRepository extends BaseService {
	abstract CheckDuplicateEmail(params: {
		email: string
		currentEmail?: string
	}): Observable<CheckDuplicateEmailTypeModel>
}
